<template>
  <div class="bage">
    <el-alert title="视频仅保存3天左右，请尽快下载" type="info" effect="dark" show-icon style="margin-bottom: 10px;">
    </el-alert>
    <!-- 新后端排队状态 -->
    <div v-if="pd.zs > 0" style="display: flex;align-items: center;gap: 8px;margin-bottom: 10px;">
      <el-tag type="success" v-if="pd.zt == 1" size="medium">
        <i class="el-icon-loading"></i>制作中您在第{{ pd.wz }}位 共{{ pd.zs }}个任务
      </el-tag>
      <el-tag type="info" v-else size="medium">
        <i class="el-icon-loading"></i>官网{{ pd.zs }}个任务在制作
      </el-tag>
    </div>
    <!-- <div style="display: flex;justify-content: flex-end;margin-bottom: 10px;">
      <el-button type="primary" icon="el-icon-refresh" circle size="small" plain></el-button>
    </div> -->
    <div style="display: flex;gap: 1px;margin-top: 10px;align-items: center;">
      <el-input size="small" placeholder="标题" clearable v-model="find_value" prefix-icon="el-icon-search"
        @keyup.enter.native=" page = 1; search(); cleartime = 1" @clear=" page = 1; jilu()"></el-input>
      <el-button size="small" type="success" @click="page = 1; search(); cleartime = 1" :loading="searchLoading">
        <span v-if="!searchLoading">查找</span>
        <span v-else>查找中...</span>
      </el-button>
      <el-button size="small" type="success" icon="el-icon-refresh" circle @click="shuaxin()"></el-button>
      <el-button :type="duoxuan_show ? 'danger' : 'primary'" size="small" icon="el-icon-edit" circle
        @click="duoxuan_show = !duoxuan_show;"></el-button>
    </div>
    <div style="margin-top: 10px;display: flex;justify-content: space-between;align-items: center;" v-if="duoxuan_show">
      <el-checkbox label="全选" v-model="quanxuan_all_value" @change="duoxuan_all"></el-checkbox>
      <div>
        <el-button type="danger" size="mini" @click="all_fc('del')">删除</el-button>
        <el-button type="info" size="mini" @click="all_fc('copy')">复制原链接</el-button>
        <el-button type="primary" size="mini" @click="all_fc('down')">下载</el-button>
      </div>
    </div>
    <ul style="overflow:auto;height: 600px;list-style:none;padding: 0;margin-top: 10px;" v-if="list.length > 0">
      <li v-for="(item, i) in list" :key="i" style="margin: 0px 0px 13px 0px;display: flex;align-items: center;">
        <el-checkbox v-if="duoxuan_show" v-model="list[i].duoxuan_status" :key="list[i].duoxuan_status"
          style="margin-right: 6px;"></el-checkbox>
        <div
          style="display:flex;padding: 7px 5px;border: 1px solid #f1f1f1;border-radius: 7px;position: relative;width: 100%;">
          <el-image style="width: 8.5vh; height: 13.5vh;border-radius:5px;" :src="item.cover" fit="cover"></el-image>
          <div style="margin-left: 10px;flex: 1;display: flex;flex-direction: column;">
            <div style="display: flex;cursor: pointer;" @click.stop="_copy(item.title)">
              <div style="display: flex;align-items: center;">
                <div class="biaoti">{{ item.title ? item.title : '无标题' }}</div>
                <div v-if="item.title"
                  style="width: 50px;text-align: center;font-size: 12px;align-items: flex-start;color: #888;background-color: #f3f3f3;border-radius: 3px;margin-left: 10px;min-width: 50px;">
                  <i class="el-icon-document-copy"></i>
                  复制
                </div>
              </div>
            </div>

            <div style="margin-top: 5px;">
              <div v-if="item.spsj">
                <el-tag size="mini" style="font-size: 12px;">{{ item.spsj }}s</el-tag>
                <el-tag size="mini" style="font-size: 12px;" type="warning">费用{{ item.kcds }}点</el-tag>
                <el-tag size="mini" style="font-size: 12px;" type="info">ID{{ item.id }}</el-tag>
                <el-tag size="mini" style="font-size: 12px;" type="info" v-if="item.zhxz">{{ item.zhxz }}</el-tag>
              </div>
            </div>
            <div style="font-size: 12px;color: #999;margin-top: 5px;">{{ item.time | formatDate }}</div>

            <!-- 使用flex-grow把按钮推到底部 -->
            <div style="flex-grow: 1;"></div>

            <!-- 所有按钮移到最下方 -->
            <div v-if="!duoxuan_show" style="display: flex;margin-top: auto;justify-content: flex-end;">
              <div class="rw_button" style="background-color: #fb5d5d;margin-right: 6px;"
                @click="del_video(item.id, i)">
                <div><i class="el-icon-delete"></i></div>
                删除
              </div>
              <div class="rw_button" style="background-color: #636363;margin-right: 6px;" @click="_copy(item.yurl)">
                <div><i class="el-icon-paperclip"></i></div>
                原链接
              </div>
              <div class="rw_button" v-if="item.zt != 2"
                :style="'background-color:' + (item.zt == 1 ? '#67c23a' : '#969696')" @click="downvideo(item, i)">
                <div><i class="el-icon-download"></i></div>
                下载视频
              </div>
            </div>
          </div>

          <div
            style="position:absolute;top: 0;bottom: 0;left: 0;right: 0;background-color: rgb(255 231 231 / 90%);z-index: 2;display: flex;justify-content: center;align-items: center;"
            v-if="item.zt == 2">
            <div>

              <div style="display: flex;align-items: center;">
                <!-- <i class="el-icon-warning" style="font-size: 20px;color: rgb(255 107 107);margin-right: 5px;"></i> -->
                <div style="font-size: 13px;">{{ item.url }}</div>
              </div>
              <div style="font-size: 12px;color:#999;text-align: center;">ID:{{ item.id }}</div>
            </div>

          </div>
        </div>

      </li>
    </ul>
    <div v-else
      style="display: flex;flex-direction: column;align-items: center;justify-content: center;height: 300px;color: #999;">
      <i class="el-icon-box" style="font-size: 48px;margin-bottom: 16px;"></i>
      <div>暂无数据</div>
    </div>


    <div style="margin-top:10px ;">
      <el-pagination background layout="total,prev, pager, next,sizes" :total="total" @current-change="fy_page"
        :current-page="page" small :page-size="page_size" @size-change="e => { page_size = e; page = 1; jilu() }"
        :page-sizes="[5, 10, 20, 30, 50]">
      </el-pagination>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）

export default {
  name: '',
  components: {

  },
  filters: {
    formatDate(value) {
      let date = new Date(value * 1000);
      //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? ('0' + MM) : MM; //月补0
      let d = date.getDate();
      d = d < 10 ? ('0' + d) : d; //天补0
      let h = date.getHours();
      h = h < 10 ? ('0' + h) : h; //小时补0
      let m = date.getMinutes();
      m = m < 10 ? ('0' + m) : m; //分钟补0
      let s = date.getSeconds();
      s = s < 10 ? ('0' + s) : s; //秒补0
      //return y + '-' + MM + '-' + d; //年月日
      //return y + '-' + MM + '-' + d + ' ' + h + ':' + m+ ':' + s; //年月日时分秒
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s; //年月日时分秒

    },
  },
  // 定义属性
  data() {
    return {
      page: 1,
      page_size: 5,
      total: 0,
      list: [],
      find_value: '',
      duoxuan: [],
      duoxuan_show: false,
      quanxuan_all_value: false,
      searchLoading: false,
      pd: { zt: 0, wz: 0, zs: 0 },
    }
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    async search() {
      this.searchLoading = true;
      try {
        await this.jilu();
      } catch (error) {
        console.error('查找失败:', error);
      } finally {
        this.searchLoading = false;
      }
    },
    async shuaxin() {
      const loading = this.$loading(this.$loadinginfo);
      try {
        this.page = 1;
        await this.jilu(); // 确保jilu返回Promise后才能await
        this.$msg.success('刷新成功');
      } catch (error) {
        this.$msg.error('刷新失败，请重试');
        console.error('刷新失败:', error);
      } finally {
        loading.close();
      }
    },
    all_fc(type) {
      console.log(this.list)
      var copys = ''
      var dels = []
      for (let index = 0; index < this.list.length; index++) {
        var item = this.list[index]
        if (item.duoxuan_status) {
          if (type == 'down') {
            this.downvideo(item, index)
          }
          if (type == 'del') {
            dels.push(item.id)
          }
          if (type == 'copy') {
            copys = copys + item.yurl + '\n'
          }
        }
      }
      if (type == 'del') {
        this.del_video(dels, 0, 1)
      }
      if (type == 'copy') {
        console.log(copys)
        this._copy(copys)
      }

    },
    duoxuan_all(e) {
      console.log(e)
      this.quanxuan_all_value = e
      for (let index = 0; index < this.list.length; index++) {
        this.$set(this.list[index], 'duoxuan_status', e)
        console.log(this.list[index].duoxuan_status)
      }
    },
    del_video(e, index, type = 0) {
      if (type == 0) {
        this.$confirm('此操作将永久删除记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const loading = this.$loading(this.$loadinginfo);
          var data = { spid: e }
          this.$ajax.post('/qhy/user/del_newsp', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
            console.log(res.data)
            if (res.data.status == 200) {
              this.list.splice(index, 1)
              this.$msg.success(res.data.msg)
            } else {
              this.$msg.error(res.data.msg)
            }
            loading.close();
          })
        }
        )
      } else {
        const loading = this.$loading(this.$loadinginfo);
        var data = { spid: e }
        this.$ajax.post('/qhy/user/del_newsp', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
          console.log(res.data)
          if (res.data.status == 200) {
            this.page = 1;
            this.jilu()
            this.quanxuan_all_value = false
            this.$msg.success(res.data.msg)
          } else {
            this.$msg.error(res.data.msg)
          }
          loading.close();
        })
      }

    },
    fy_page(e) {
      console.log(e)
      this.quanxuan_all_value = false
      this.page = e
      this.jilu()
    },
    downvideo(e, i) {
      if (e.zt == 2) {
        return
      }
      this.list[i].zt = 0
      this.downvideo_ok(e.id);
      window.open(e.url, "_blank");
    },
    downvideo_ok(id) {
      var data = { id: id }
      this.$ajax.post('/qhy/user/down_ok', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
        // console.log(res.data)

      })
    },
    _copy(context) {
      // 创建输入框元素
      try {
        let oInput = document.createElement('textarea');
        // 将想要复制的值

        oInput.value = context.replaceAll("qhy7672", "\n");;
        // 页面底部追加输入框
        document.body.appendChild(oInput);
        // 选中输入框
        oInput.select();
        // 执行浏览器复制命令
        document.execCommand('Copy');
        // 弹出复制成功信息
        this.$message.info('复制成功');
        // 复制后移除输入框
        oInput.remove();
      } catch (e) {
        this.$message.error('复制失败,此任务没有原链接');
      }


    },
    jilu(force = 1) { // 返回Promise供外部await
      return new Promise((resolve, reject) => {
        this.$ajax.post('/qhy/user/record', {
          page: this.page,
          find: this.find_value,
          pagesize: this.page_size,
        }, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        }).then(res => {
          if (res.data.status === 200) {
            this.total = res.data.data.total;
            if (this.duoxuan_show == false || force == 1) {
              this.list = res.data.data.data
            }
            resolve(res.data);
          } else {
            this.$msg.error(res.data.msg);
            reject(new Error(res.data.msg));
          }
        }).catch(error => {
          this.$msg.error('接口请求失败');
          reject(error);
        });
      });
    },
    jsc_fc() {
      this.timer = setInterval(() => {
        console.log('任务计时器', this.$callrecord.status)
        if (this.$callrecord.status == 1) {
          this.jilu(0)
        }
      }, 5000)
    },
    getPaidui() {
      this.$ajax.get('api/v1/users/paidui').then(res => {
        if (res.data && res.data.status === 200 && res.data.pd) {
          this.pd = res.data.pd
          if (res.data.pd.zt == 1) {
            // 有排队任务：5 秒轮询，直到没有排队
            if (!this.pdTimer) {
              this.pdTimer = setInterval(() => this.getPaidui(), 5000)
            }
          } else {
            // 没有排队任务：停止轮询
            this.stopPaidui()
          }
        }
      }).catch(() => { })
    },
    stopPaidui() {
      if (this.pdTimer) {
        clearInterval(this.pdTimer)
        this.pdTimer = null
      }
    }

  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.jilu()
    this.dsq_time = this.common.time_10() + 1800//定时30分钟无操作清除定时器
    this.cleartime = 0
    this.jsc_fc()
    this.getPaidui()
    // this.timer = setInterval(() => {
    //   console.log('计时器')
    //   if (this.cleartime == 1 || this.dsq_time < this.common.time_10()) {
    //     clearInterval(this.timer);
    //     this.timer = null;
    //   } else {
    //     this.jilu(0)
    //   }
    // }, 5000)
    this.common.ismobile(this)
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() { }, // 生命周期 - 创建之前
  beforeMount() { }, // 生命周期 - 挂载之前
  beforeUpdate() { }, // 生命周期 - 更新之前
  updated() { }, // 生命周期 - 更新之后
  beforeDestroy() {
    this.stopPaidui()
  }, // 生命周期 - 销毁之前
  destroyed() { this.cleartime = 1 }, // 生命周期 - 销毁完成
  activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
.biaoti {
  font-size: 1.5vh;
  color: #555;
  overflow: hidden;
  word-break: break-all;
  /* break-all(允许在单词内换行。) */
  text-overflow: ellipsis;
  /* 超出部分省略号 */
  display: -webkit-box;
  /** 对象作为伸缩盒子模型显示 **/
  -webkit-box-orient: vertical;
  /** 设置或检索伸缩盒对象的子元素的排列方式 **/
  -webkit-line-clamp: 2;
  /** 显示的行数修改为2行 **/
  line-height: 1.4;
  /** 设置行高以确保两行显示效果更好 **/
}

.i-botton {
  width: 30px;
  height: 30px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* font-size: 12px; */
  margin: 0px 3px;
}

.rw_icon {
  background-color: #888;
  border-radius: 50%;
  height: 28px;
  width: 28px;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  cursor: pointer;
  margin: 4px;
}

.el-tag {
  margin: 2px 0px;
}

.bage>>>.el-checkbox__inner {
  width: 16px;
  height: 16px;
}

.rw_button {
  background-color: #636363;
  font-size: 1.3vh;
  display: flex;
  align-items: center;
  padding: 0.5vh 1vh;
  color: #fff;
  border-radius: 1.4vh;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/User/Record.vue



// WEBPACK FOOTER //
// src/components/User/Record.vue